import React from 'react'

type Props = {
  accountId: string
}

const DocumentsList: React.FC<Props> = ({ accountId }) => {
  return (
    <div className='admin-investor__empty-state'>
      Documents are not available yet for investor {accountId}.
    </div>
  )
}

export default DocumentsList

